import { CommonRequestParams } from "api/api.types"
import { snakelize, camelize } from "../../../helpers/object"
import { GetSettingsResponse } from "./settings.types"

export default ($axios: any): any => ({
  /**
   * 서비스 설정 목록 불러오기
   */
  async getSettings(data?: CommonRequestParams): Promise<GetSettingsResponse> {
    return camelize(await $axios.get(`/settings`, snakelize({ params: data })))
  },
  /**
   * 설정 목록
   * @deprecated
   */
  async index(data?: any) {
    return camelize(await $axios.get(`/settings`, snakelize({ params: data })))
  },
})
